// extracted by mini-css-extract-plugin
export default {"spotlightWrapper":"style_spotlightWrapper__VAff+","container":"style_container__NLSiW","gateMessage":"style_gateMessage__DOngU"};